// extracted by mini-css-extract-plugin
module.exports = {"item":"accordionItemMobile__item--FTp0n","link":"accordionItemMobile__link--31km_","content":"accordionItemMobile__content--3dhm2","img":"accordionItemMobile__img--1WFpY"};